import { styled } from "styled-components";

export const SearchLinksSectionWrapper = styled.section`
  display: flex;
  padding: 96px 0;
  justify-content: center;
  width: 100%;
`;

export const SearchLinksSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  align-items: center;
  gap: 48px;
  width: 100%;
  padding: 0 24px;
`;

export const TitleSection = styled.div`
  display: flex;
  width: 100%;

  ${({ theme }) => theme.breakpoints.md.query} {
    justify-content: center;
    text-align: center;
  }
`;

export const CardsSection = styled.div`
  width: 100%;
  gap: 24px;
  display: flex;
  align-self: stretch;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
  }
`;

export const SearchCard = styled.div`
  width: 100%;
  min-height: 208px;
  padding: 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.default[50]};
  border: 1px solid ${({ theme }) => theme.colors.default[100]};
`;

export const InputSection = styled.form`
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    
    > div {
        height: fit-content;
    }
}

    ${({ theme }) => theme.breakpoints.sm.query} {
        flex-direction: column;

        & > * {
            width: 100%;
        }

`;
